<template>
    <div>
        <v-toolbar
                dense
                :tabs="!hideTabs"
                color="primary"
                dark
        >
            <v-toolbar-title class="pl-2">Pago en Linea con Tarjeta</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tabs
            v-if="!hideTabs"
                    v-model="tabs"
                    color="transparent"
                    slider-color="white"
                    slot="extension"
            >
                <v-tab
                        v-for="tabsItem in tabsItems"
                        :key="tabsItem.id"
                        :to="tabsItem.link"
                >
                    <span class="pl-2 pr-2">{{ tabsItem.title }}</span>
                </v-tab>
            </v-tabs>
        </v-toolbar>

        <v-container>

                
                    <v-slide-y-transition mode="out-in">
                        <router-view/>
                    </v-slide-y-transition>
                
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabs: null,
                hideTabs: false,
                tabsItems: [
                    {id: 1, title: 'Resumen', link: {path: `/pagoenlinea/resumen`}},
                    {id: 2, title: 'Configuracion', link: {path: `/pagoenlinea/configuracion`}},
                    {id: 3, title: 'Pagos', link: {path: `/pagoenlinea/pagos`}},
                    {id: 4, title: 'Depositos', link: {path: `/pagoenlinea/depositos`}}
                    
                ]
            }
        },
        mounted () {
            if (this.$System.currentUser.Negocio && !this.$System.currentUser.Negocio.stripe.enabled) {
                this.hideTabs = true
                this.$router.push('/pagoenlinea/activar')
            } else {
                this.hideTabs = false
            }
        }
    }
</script>

<style scoped>

</style>
